import React, { Component } from 'react';
//import { Grid, Row, Col } from 'react-bootstrap';
//import './Footer.css'
import SimplifiedLayout from '../SimplifiedLayout.js';
import Helmet from 'react-helmet';

class Privacy extends Component {
	render() {

		return (
			<div>

			<Helmet title="Privacy"/>
                <SimplifiedLayout fixedNavbar={true}>


<div className="container">

<h1>Privacy policy</h1>

<p><b><span>1. Introduction</span></b></p>

<p><span>1.1 We are
committed to guarding the privacy of our all of our website visitors. In the
following policy we will outline our procedures on how we will treat your
personal information.</span></p>

<p><span>1.2 We will
request you to consent to our use of cookies in accordance with the terms of
this policy when you first visit our website. By the use of our website you
consent to our use of cookies in accordance with the terms of this policy.</span></p>

<p><b><span>2. Website</span></b></p>

<p><span>2.1 This
policy is set out for the use of and should be interpreted by users for www.webfinery.com.</span></p>

<p><b><span>3. Collecting
personal information</span></b></p>

<p>We
abide and follow accepted standards to protect user information. No method of
electronic storage is completely secure. We do not guarantee that your
communications, or personal information will remain 100% safe from misuse. You
agree that we are not liable for theft, or unauthorized access. You acknowledge
that you understand and agree to assume these risks.</p>

<p><b><span></span></b></p>

<p><span>3.1 We may
collect, store and use the following kinds of personal information: </span></p>

<p>(a) Information
regarding your computer specifications and about your use of this website
(including your IP address, geographical location, browser type and version,
operating system, referral source, length of visit, page views and website
navigation paths.)</p>

<p>(b) Information
that you provide to us when registering with our website (including your email
address.)</p>

<p>(c) Information
that you provide when completing your profile on our website including your
name, profile pictures, gender, date of birth.</p>

<p>(d) Information
that you provide to us for the purpose of subscribing to our email
notifications or newsletters.</p>

<p>(e) Information
that you provide to us when using the services on our website, or that is
generated in the course of the use of those services (including the timing,
frequency and pattern of service use).</p>

<p>(f) Information
relating to any purchases you make of our goods and services or any other
transactions that you enter into through our website.</p>

<p><b><span>4. Using
your personal information</span></b></p>

<p><span>4.1 Personal
information submitted to us will be used for the purposes specified in this
policy or on the relevant pages of the website.</span></p>

<p><span>4.2 We may
use your personal information to: </span></p>

<p>(a) administer
our website and business</p>

<p>(b) enable
your use of the services available on our website</p>

<p>(c) send
you goods purchased through our website</p>

<p>(d) supply
to you services purchased through our website</p>

<p>(e) send
statements, invoices and payment reminders to you, and collect payments from
you.</p>

<p>(f) send
you non-marketing commercial communications</p>

<p>(g) send
you our email newsletter</p>

<p>(h) send
you marketing communications relating to our business.</p>

<p>(i) provide
third parties with statistical information about our users (but those third
parties will not be able to identify any individual user from that information.</p>

<p><span></span></p>

<p><span>4.3 We will
not, without your express consent, supply your personal information to any
third party for the purpose of any other third party's direct marketing.</span></p>

<p><span></span></p>

<p><b><span>5. Disclosing
personal information</span></b></p>

<p><span>5.1 We may
disclose your personal information to as reasonably necessary for the purposes
set out in this policy.</span></p>

<p><span>5.2 We may
disclose your personal information to any member of our group of companies for
the purposes set out in this policy.</span></p>

<p><span>5.3 We can
disclose your personal information: </span></p>

<p>(a) Where
required by law</p>

<p>(b) To
a person who we reasonably believe may apply to a court or other competent
authority for disclosure of that personal information where, in our reasonable
opinion, such court or authority would be reasonably likely to order disclosure
of that personal information.</p>

<p><span>5.4 Except
as provided in this policy, we will not provide your personal information to
third parties.</span></p>

<p><b><span>6. International
data transfers</span></b></p>

<p><span>6.1 Information
that we collect may be stored and processed in and transferred between any of
the countries in which we operate in order to enable us to use the information
in accordance with this policy.</span></p>

<p><span>6.2 Personal
information that you publish on our website or submit for publication on our
website may be available, via the internet, around the world. We cannot prevent
the use or misuse of such information by others.</span></p>

<p><span>6.3 You
hereby agree to the transfers of personal information described in this section</span></p>

<p><b><span>7. Personal
information</span></b></p>

<p><span>7.1 Personal
information that we process for any purpose or purposes shall not be kept for
longer than is necessary for that purpose or those purposes.</span></p>

<p><span>7.2  will
retain documents containing personal data: </span></p>

<p>(a) to
the extent that we are required to do so by law;</p>

<p>(b) in
order to establish, exercise or defend our legal rights (including providing
information to others for the purposes of fraud prevention and reducing credit
risk).</p>

<p><b><span>8. Security
of your personal information</span></b></p>

<p><span>8.1 We will
take reasonable technical and organisational precautions to prevent the loss,
misuse or alteration of your personal information.</span></p>

<p><span>8.2 We will
store all the personal information you provide on our secure servers.</span></p>

<p><span>8.3 You
acknowledge that the transmission of information over the internet is
inherently insecure, and we cannot guarantee the security of data sent over the
internet.</span></p>

<p><b><span>9. Future
amendments</span></b></p>

<p><span>9.1 We may
update this policy from time as we see necessary from time by publishing a new
version on our website.</span></p>

<p><span>9.2 You
should check this page occasionally to ensure you are happy with any changes to
this policy.</span></p>

<p><span></span></p>

<p><b><span>10. Your
rights</span></b></p>

<p><span>10.1 You may instruct us
to provide you with any personal information we hold about you; provision of
such information will be subject to: </span></p>

<p>(a) the
supply of appropriate evidence of your identity</p>

<p><span>10.2 We may withhold
personal information that you request to the extent permitted by law.</span></p>

<p><span></span></p>

<p><b><span>11. Third
party websites</span></b></p>

<p><span>11.1 Our website
includes hyperlinks to, and details of, third party websites.</span></p>

<p><span>11.2 We have no control
over, and are not responsible for, the privacy policies and practices of third
parties. This includes the use of our third payment websites paypal.com and
stripe.com.</span></p>

<p><b><span>12. Updating
information</span></b></p>

<p><span>12.1 Please let us know
if the personal information that we hold about you needs to be corrected or
updated.</span></p>

<p><b><span>13. Cookies</span></b></p>

<p><span>13.1 Our website is
subject to the use of cookies.</span></p>

<p><span>13.2 A cookie is a file
containing an identifier (a string of letters and numbers) that is sent by a
web server to a web browser and is stored by the browser. The identifier is
then sent back to the server each time the browser requests a page from the
server.</span></p>

<p><span>13.3 Cookies may be
either &quot;persistent&quot; cookies or &quot;session&quot; cookies: a
persistent cookie will be stored by a web browser and will remain valid until
its set expiry date, unless deleted by the user before the expiry date; a
session cookie, on the other hand, will expire at the end of the user session,
when the web browser is closed. </span></p>

<p><span>13.4 Cookies do not
typically contain any information that personally identifies a user, but
personal information that we store about you may be linked to the information
stored in and obtained from cookies.</span></p>

<p><span>13.5 Most browsers allow
you to refuse to accept cookies; for example: </span></p>

<p>(a) in
Internet Explorer (version 10) you can block cookies using the cookie handling
override settings available by clicking &quot;Tools&quot;, &quot;Internet
Options&quot;, &quot;Privacy&quot; and then &quot;Advanced&quot;;</p>

<p>(b) in
Firefox (version 24) you can block all cookies by clicking &quot;Tools&quot;,
&quot;Options&quot;, &quot;Privacy&quot;, selecting &quot;Use custom settings
for history&quot; from the drop-down menu, and unticking &quot;Accept cookies
from sites&quot;; and</p>

<p>(c) in
Chrome (version 29), you can block all cookies by accessing the &quot;Customise
and control&quot; menu, and clicking &quot;Settings&quot;, &quot;Show advanced
settings&quot; and &quot;Content settings&quot;, and then selecting &quot;Block
sites from setting any data&quot; under the &quot;Cookies&quot; heading.</p>

<p><span>13.5 Blocking all
cookies will have a negative impact upon the usability of many websites.</span></p>

<p><span>13.7 If you block
cookies, you will not be able to use all the features on our website.</span></p>

<p><span>13.8 You can delete
cookies already stored on your computer; for example:</span></p>

<p>(a) in
Internet Explorer (version 10), you must manually delete cookie files (you can
find instructions for doing so at http://support.microsoft.com/kb/278835);</p>

<p>(b) in
Firefox (version 24), you can delete cookies by clicking &quot;Tools&quot;,
&quot;Options&quot; and &quot;Privacy&quot;, then selecting &quot;Use custom
settings for history&quot;, clicking &quot;Show Cookies&quot;, and then
clicking &quot;Remove All Cookies&quot;; and</p>

<p>(c) in
Chrome (version 29), you can delete all cookies by accessing the
&quot;Customise and control&quot; menu, and clicking &quot;Settings&quot;,
&quot;Show advanced settings&quot; and &quot;Clear browsing data&quot;, and
then selecting &quot;Delete cookies and other site and plug-in data&quot;
before clicking &quot;Clear browsing data&quot;.</p>

<p><span>13.9 Deleting cookies will
have a negative impact on the usability of many websites.</span></p>


</div> 
</SimplifiedLayout>
</div>

        )
	}
}

export default Privacy;


// WEBPACK FOOTER //
// ./src/content/Privacy.js